const AUTH_STORAGE_PREFIX = '@ME:'
const SESSION_EXPIRED_KEY = '@ME:session_expired'

/**
 * Remove apenas as chaves de autenticacao do localStorage (prefixo @ME:),
 * preservando dados de terceiros (ex: Vuetify, feature flags externos).
 */
export function clearAuthStorage(): void {
  const keysToRemove: string[] = []

  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i)
    if (key?.startsWith(AUTH_STORAGE_PREFIX)) {
      keysToRemove.push(key)
    }
  }

  keysToRemove.forEach((key) => localStorage.removeItem(key))
}

/**
 * Marca que a sessão do usuário expirou (401), para a tela de login exibir
 * aviso após o redirect. Usa sessionStorage — não é tocado por clearAuthStorage
 * e sobrevive ao redirect na mesma aba. Try/catch: storage pode estar bloqueado.
 */
export function setSessionExpiredFlag(): void {
  try {
    sessionStorage.setItem(SESSION_EXPIRED_KEY, '1')
  } catch {
    // sessionStorage indisponível/bloqueado — segue sem a flag (sem aviso no login)
  }
}

/**
 * Lê e REMOVE a flag de sessão expirada (one-shot): true apenas na primeira
 * leitura após um 401; reloads subsequentes retornam false.
 */
export function consumeSessionExpiredFlag(): boolean {
  try {
    const hasFlag = sessionStorage.getItem(SESSION_EXPIRED_KEY) === '1'
    if (hasFlag) sessionStorage.removeItem(SESSION_EXPIRED_KEY)
    return hasFlag
  } catch {
    return false
  }
}

/**
 * Espelha o check dos guards do router: usuário-empresa autenticado possui
 * @ME:access_token não vazio (médico usa @ME:doctor_access_token). SSR-safe.
 */
export function isCompanyAuthenticated(): boolean {
  if (typeof window === 'undefined') return false

  const accessToken = localStorage.getItem('@ME:access_token')
  return accessToken !== null && accessToken !== ''
}

/**
 * Token do Portal do Afiliado Antecipe (persona ANTECIPE_AFFILIATE). Chave própria,
 * com o prefixo @ME: para o clearAuthStorage levá-lo junto no logout/401.
 */
export const AFFILIATE_TOKEN_KEY = '@ME:affiliate_token'

export function getAffiliateToken(): string | null {
  try {
    const token = localStorage.getItem(AFFILIATE_TOKEN_KEY)
    return token ? token : null
  } catch {
    return null
  }
}

export function setAffiliateToken(token: string): void {
  localStorage.setItem(AFFILIATE_TOKEN_KEY, token)
}

/** Espelha isCompanyAuthenticated para o afiliado. SSR-safe. */
export function isAffiliateAuthenticated(): boolean {
  if (typeof window === 'undefined') return false
  return getAffiliateToken() !== null
}
